var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell } from "@mui/material";
import clsx from "clsx";
import { useMemo } from "react";
import { useStyles } from "./ui_table_cell.css";
export const UiTableCell = (_a) => {
    var { align = "left", children, className, maxWidth, minWidth, width, whiteSpace } = _a, props = __rest(_a, ["align", "children", "className", "maxWidth", "minWidth", "width", "whiteSpace"]);
    const classes = useStyles({ maxWidth, minWidth, whiteSpace, width });
    return useMemo(() => (_jsx(TableCell, Object.assign({ align: align, className: clsx(classes.table_cell, className) }, props, { children: children }))), [align, children, className, classes.table_cell, props]);
};
//# sourceMappingURL=ui_table_cell.js.map